import React from 'react';
import { OnlineTransactionReportTable } from './partials/OnlineTransactionReport';

export const OnlineTransactionReport = () => {

  return (
    <div><OnlineTransactionReportTable /></div>
  )
}
